<template>
    <div class="table-user">
        <div class="table-user-header">
            <b-row class="pt-3 pb-4 align-items-end">
                <search-field @searchValue="event => searchField(event)"></search-field>
                <b-col class="text-right ">
                    <b-btn type="button"
                           class="ml-2"
                           variant="primary-user"
                           size="sm"
                           @click="openTableSettingsModal">Table Settings
                    </b-btn>
                </b-col>
            </b-row>
        </div>
        <div class="scroll-x">
            <table-element
                :items="items"
                :fields="tableFields"
                @sort="event => sortTable(event)">
                <select-filter slot="HEAD_marketplaceRelation.marketplaces"
                               name="origin-product-select-filter"
                               filterType="service"
                               slot-scope="data"
                               :options="originProduct"
                               placeholder="Origin"
                               @filtered="event => filterTable(event, true)"/>
                <template slot="marketplaceRelation.marketplaces" slot-scope="data">
                    <div v-for="(marketplace, index) in data.value" :key="index">
                        {{marketplace}}<span v-if="data.value.length > 1">, </span>
                    </div>
                </template>
                <b-btn slot="actions"
                       slot-scope="data"
                       variant="primary-user"
                       size="sm"
                       :to="{name: 'SingleProduct', params: {id: data.item.id}}">
                    Fill required fields
                </b-btn>
            </table-element>
        </div>
        <div class="table-user-footer">
            <!-- Pagination -->
            <table-pagination
                v-if="settingsPaginationFromApi.total >= quantityProductOnPage"
                :settings="settingsPaginationFromApi"
                :perPageArray="quantityProductVariations"
                @paginateAction="updatePagination"/>
        </div>
        <modal-table-settings :tableSettings="suspendedColumns"
                              :defaultTableSettings="defaultSuspendedColumns"
                              :selectedColumns="$store.state.suspendedColumns"
                              :localStorageItemName="'suspendedProductColumns'"
                              :storeCommitName="'UPDATE_SUSPENDED_COLUMNS'"/>
    </div>
</template>

<script>
    import {tableMixins, paginationMixin, routePaginationMixin} from '@/mixins/tableMixins'

    import TableElement from '~cp/UserPanel/Elements/TableElement'
    import TablePagination from '~cp/UserPanel/Elements/TablePagination'
    import ModalTableSettings from '~cp/UserPanel/Modals/ManagementTableSettings'
    import SelectFilter from '~cp/UserPanel/Elements/TableSelectField'
    import SearchField from '~cp/UserPanel/Elements/SearchField'

    import suspendedProducts from '@/assets/js/columns/suspendedProducts'
    import defaultSuspendedProducts from '@/assets/js/columns/defaultSuspendedProducts'
    import originItem from '@/assets/js/table-options/originItem'

    export default {
        name: 'IntegrateProducts',
        mixins: [tableMixins, paginationMixin, routePaginationMixin],
        components: {
            TableElement,
            TablePagination,
            ModalTableSettings,
            SelectFilter,
            SearchField
        },
        data() {
            return {
                productsId: [],
                requiredApiParams: {
                    'filter[status]': 'suspended',
                },
                originProduct: originItem,
                suspendedColumns: suspendedProducts,
                defaultSuspendedColumns: defaultSuspendedProducts
            }
        },
        computed: {
            tableFields() {
                const {suspendedColumns} = this.$store.state
                return [...suspendedColumns, {key: 'actions', label: ''}]
            },
        },
        methods: {
            openTableSettingsModal() {
                this.$root.$emit('bv::show::modal', 'tableSettings')
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/UserPanel/Pages/Inventory/AddProducts/IntegrateProducts.vue